import {
  Typography,
  Switch,
  TextField,
  MenuItem,
  Card,
  CardContent,
  Box,
} from '@mui/material';
import BrindeImagem from './BrindeImagem';

const BrindePorNivelSection = ({
  nivel,
  brindes,
  brindesPorNivelTemp,
  setBrindesPorNivelTemp,
  salvarBrindePorNivel,
}) => {
  const handleToggle = async (e) => {
    const checked = e.target.checked;
    if (checked) {
      setBrindesPorNivelTemp((prev) => ({
        ...prev,
        [nivel]: "",
      }));
    } else {
      const novo = { ...brindesPorNivelTemp };
      delete novo[nivel];
      setBrindesPorNivelTemp(novo);
      await salvarBrindePorNivel(nivel, null);
    }
  };

  const handleChangeSelect = async (e) => {
    const novoBrindeId = e.target.value;
    setBrindesPorNivelTemp((prev) => ({
      ...prev,
      [nivel]: novoBrindeId,
    }));
    await salvarBrindePorNivel(nivel, novoBrindeId);
  };

  const brindeSelecionado = brindes.find((b) => b.id === brindesPorNivelTemp[nivel]);

  return (
    <Box mt={2}>
      <Typography variant="body2" fontWeight="bold" sx={{ mb: 1 }}>
        Brinde no Nível:
      </Typography>

      <Switch
        checked={brindesPorNivelTemp[nivel] !== undefined}
        onChange={handleToggle}
        sx={{ mb: 2 }}
      />

      {brindesPorNivelTemp[nivel] !== undefined && (
        <>
          <TextField
            select
            fullWidth
            value={brindesPorNivelTemp[nivel] || ""}
            onChange={handleChangeSelect}
            sx={{ mb: 2 }}
          >
            <MenuItem value="">Sem brinde no nível</MenuItem>
            {brindes.map((b) => (
              <MenuItem key={b.id} value={b.id}>
                {b.nome}
              </MenuItem>
            ))}
          </TextField>

          {!!brindesPorNivelTemp[nivel] && brindeSelecionado && (
            <Card
              sx={{
                maxWidth: 420,
                mx: 'auto',
                my: 3,
                backgroundColor: 'transparent',
                boxShadow: 'none',
              }}
            >
              <CardContent
                sx={{
                  position: 'relative',
                  backgroundColor: '#fff',
                  borderRadius: '16px',
                  p: 2,
                  backgroundImage: 'url(/background3.png)',
                  backgroundRepeat: 'repeat',
                  backgroundSize: '200px',
                  backgroundPosition: 'top left',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 16,
                    left: -8,
                    width: 0,
                    height: 0,
                    borderTop: '8px solid transparent',
                    borderBottom: '8px solid transparent',
                    borderRight: '8px solid #fff',
                  },
                }}
              >
                <BrindeImagem src={brindeSelecionado.imagem_url} />
              </CardContent>
            </Card>
          )}
        </>
      )}
    </Box>
  );
};

export default BrindePorNivelSection;
